import React, { Fragment } from "react";
import { Paper, Container, Grid, Box } from "@mui/material";
import { makeStyles } from '@mui/styles';
import CITILOGO from "../../assets/icons/CITI.svg";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const classStyles = makeStyles(() => ({
    headerContainer: {
        display: "flex",
        height: "56px",
        position: "fixed",
        top: '0',
        width: "100vw",
        alignItems: "center",
        zIndex: 999,
        boxSizing: "border-box",
        boxShadow:
            "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);",
    },
    nowrap: {
        flexWrap: "nowrap",
        alignItems: "center",
    },
    logoContainer: {
        display: "flex",
        alignItems: "center",
    },
    citiLogo: {
        display: "flex",
    },
    clientLogo: {
        width: '41px',
        objectFit: "contain",
    },
    headerSmText: {
        alignItems: "center",
        display: "flex",
        fontSize: "16px",
        color: "#4C4C4C",
        fontFamily: `'Roboto', sans-serif`,
        fontWeight: 600,
        marginLeft:'16px'
    },
    rightNavContainer: {
        display: "flex",
        // flexGrow: 1,
        alignItems: "center",
      },
}))
const Header = () => {
    const classes = classStyles();
    return <Fragment>
        <Paper square className={classes.headerContainer}>
            <Container maxWidth="1">
                <Grid
                    item
                    container
                    justifyContent="space-between"
                    className={classes.nowrap}
                >
                    <Box className={classes.logoContainer}>
                        <Box className={classes.citiLogo}>
                            <Box display="flex" justifyContent="center">
                                <img
                                    src={CITILOGO}
                                    alt="CITI"
                                    className={classes.clientLogo}
                                    height="45"
                                />{" "}
                            </Box>
                        </Box>
                        <Box className={classes.headerSmText}>
                            Payment Exchange
                        </Box>
                    </Box>
                    <Box className={classes.rightNavContainer}>
                        <Box>
                        <Box
                        display={{
                          xs: "block",
                          sm: "block",
                          md: "none",
                          lg: "none",
                          xl: "none",
                        }}
                      >
                        {"English"}
                        <KeyboardArrowDownIcon />
                      </Box>
                        </Box>
                    </Box>
                </Grid>
            </Container>
        </Paper>
    </Fragment>
}

export default Header;
